import StandardGateway from '@ad-scripts/adapters/gateways/lib/standard_gateway';

const DEFAULT_TIMEOUT = 10000;

export default class SearchDropdownResultHttpGateway extends StandardGateway {
  constructor(backend) {
    super(backend, { fetchUrl: '/api/v1/orgs/:orgId/search/snippets' });
  }

  request(fieldName, id, params) {
    let url = this.endpoint.set(params).fetchUrl;

    return this.http
      .post(url, params, { timeout: DEFAULT_TIMEOUT })
      .then(data => {
        this.observer.onFetchSuccess({ fieldName, data, id });
      })
      .catch(error => {
        this.observer.onFetchError(fieldName, error);
      });
  }
}
